export default __webpack_public_path__ + "static/media/loader.6b11e1f2.svg";